const IDENTITY_COLOR_VARS = ['--identity-1', '--identity-2', '--identity-3', '--identity-4'];

/**
 * Deterministically maps a name/id to one of the four `--identity-*` hues
 * defined in `src/index.css` (the same vetted, dark-mode-safe hues the
 * health-score pillar ring uses) — the same input always resolves to the
 * same hue, so a person reads as one consistent color everywhere they
 * appear. Not cryptographic; just needs to spread names across 4 buckets.
 */
export function identityColorVar(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % IDENTITY_COLOR_VARS.length;
  return IDENTITY_COLOR_VARS[index];
}
